const TIME_ANCHOR_DATE = "1970-01-01";
const TIME_VALUE_REGEX = /^(\d{1,2}):([0-5]\d)(?::([0-5]\d)(?:\.(\d{1,4}))?)?(?:Z|[+-]\d{2}:?\d{2})?$/;
const FRACTIONAL_SECOND_DIGITS = 4;

export const padTimePart = (value) => `${value}`.padStart(2, "0");

const padFractionalSecondPart = (value) => `${value ?? "0"}`.padEnd(FRACTIONAL_SECOND_DIGITS, "0").substring(0, FRACTIONAL_SECOND_DIGITS);

export const parseTimeValue = (value) => {
	if(value === undefined || value === null || value === "") {
		return undefined;
	}

	if(value instanceof Date) {
		return {
			hour: value.getHours(),
			minute: value.getMinutes(),
			second: value.getSeconds(),
			fractionalSecond: padFractionalSecondPart(`${value.getMilliseconds()}`.padStart(3, "0"))
		};
	}

	const source = `${value}`.trim();
	const timePart = source.indexOf("T") > -1 ? source.substring(source.indexOf("T") + 1) : source.replace(/^T/, "");
	const match = timePart.match(TIME_VALUE_REGEX);

	if(!match) {
		return undefined;
	}

	const hour = parseInt(match[1], 10);
	const minute = parseInt(match[2], 10);
	const second = parseInt(match[3] ?? "0", 10);
	const fractionalSecond = padFractionalSecondPart(match[4]);

	if(hour > 23) {
		return undefined;
	}

	return {
		hour,
		minute,
		second,
		fractionalSecond
	};
};

export const buildTimeValue = (timeParts) => {
	if(!timeParts) {
		return undefined;
	}

	return `${padTimePart(timeParts.hour)}:${padTimePart(timeParts.minute)}:${padTimePart(timeParts.second ?? 0)}.${padFractionalSecondPart(timeParts.fractionalSecond)}`;
};

export const normalizeTimeValue = (value) => buildTimeValue(parseTimeValue(value));

export const buildAnchoredTimeValue = (value) => {
	const normalizedTime = normalizeTimeValue(value);

	return normalizedTime === undefined ? undefined : `${TIME_ANCHOR_DATE}T${normalizedTime}Z`;
};

export const toTwelveHourParts = (value) => {
	const timeParts = parseTimeValue(value);

	if(!timeParts) {
		return undefined;
	}

	const period = timeParts.hour >= 12 ? "PM" : "AM";
	const hour = timeParts.hour % 12 || 12;

	return {
		hour: `${hour}`,
		minute: padTimePart(timeParts.minute),
		period
	};
};
